import * as React from 'react';

export const PAGE_TYPE = {
  OFFER: 'offer',
  CONTENT: 'content'
};

const DeliverableContentContext = React.createContext(PAGE_TYPE.OFFER);

export default DeliverableContentContext;
